import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";

export const getMedicalTermList = async (api, params) => {
  const res = await afterLoginApiAxios({
    method: "get",
    params: params,
    url: api,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    if (res?.data?.statusCode === 200) {
      if (res?.data?.data?.length > 0) {
        res.data.data.forEach((data) => {
          data["label"] = data?.title;
          data["value"] = data?.title;
          data["showPainScale"] = false;
          data["painScaleData"] = { title: data?.title };
        });
      }
      return [res?.data?.data, res?.data?.total_count, false];
    }
    return [[], 0, false];
  }
  return [null, true]; // [response, error]
};

export const getDiagnosisList = async (api, params) => {
  const res = await afterLoginApiAxios({
    method: "get",
    params: params,
    url: api,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    if (res?.data?.statusCode === 200) {
      if (res?.data?.data?.length > 0) {
        res.data.data.forEach((data) => {
          data["label"] = data?.title;
          data["value"] = data?.title;
        });
      }
      return [res?.data?.data, res?.data?.total_count, false];
    }
    return [[], false];
  }
  return [null, true]; // [response, error]
};

export const addUpdatePrescriptionData = async (payload, api, method) => {
  const res = await afterLoginApiAxios({
    method: method,
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const getReportList = async (api, params) => {
  const res = await afterLoginApiAxios({
    method: "get",
    params: params,
    url: api,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    if (res?.data?.statusCode === 200) {
      if (res?.data?.data?.length > 0) {
        res.data.data.forEach((data) => {
          data["label"] = data?.title;
          data["value"] = data?.title;
        });
      }
      return [res?.data?.data, res?.data?.total_count, false];
    }
    return [[], 0, false];
  }
  return [null, true]; // [response, error]
};
export const investigationAndNotesSearch = async (api, params) => {
  const res = await afterLoginApiAxios({
    method: "get",
    params: params,
    url: api,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    if (res?.data?.statusCode === 200) {
      if (res?.data?.data?.length > 0) {
        res.data.data.forEach((data) => {
          data["label"] = data?.title;
          data["value"] = data?.title;
        });
      }
      return [res?.data?.data, res?.data?.total_count, false];
    }
    return [[], 0, false];
  }
  return [null, true]; // [response, error]
};

export const getDoctorNotes = async (id, params) => {
  let api = `/api/v1/prescription/${id}/prescription-notes`;
  const res = await afterLoginApiAxios({
    method: "get",
    params: params,
    url: api,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    if (res?.data?.statusCode === 200) {
      return [res?.data?.data, res?.data?.total_count, false];
    }
    return [[], 0, false];
  }
  return [null, 0, true]; // [response, error]
};
